import React from 'react'
import SubTitle from '../../components/common/SubTitle'
import TitleBar from '../../components/navbar/TitleBar'
import NavMenu from '../../components/navbar/NavMenu'
import AdminOrgMoreMain from '../../components/organization/AdminOrgMoreMain'
export default function AdminOrgMore() {
  return (
    <>
    <TitleBar/>
    <NavMenu/>
    <AdminOrgMoreMain/>
    </>
  )
}
